import { render, staticRenderFns } from "./EditRiskViewpoint.vue?vue&type=template&id=b953a86c&scoped=true"
import script from "./EditRiskViewpoint.vue?vue&type=script&lang=js"
export * from "./EditRiskViewpoint.vue?vue&type=script&lang=js"
import style0 from "./EditRiskViewpoint.vue?vue&type=style&index=0&id=b953a86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b953a86c",
  null
  
)

export default component.exports